import { render, staticRenderFns } from "./menu-icon.vue?vue&type=template&id=d9bd4608&"
import script from "./menu-icon.vue?vue&type=script&lang=js&"
export * from "./menu-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports